import React from 'react'

const DataInput = (props) => {
    const { handleFile } = props;
    const handleChange = (e) => {
      const files = e.target.files;
      
      // setQuestion({ excelFile: files });
      props.setFileData(files);
      if (files && files[0]) handleFile(files[0]);
    };
  
    const SheetJSFT = [    
      "xlsx",
      "xlsb",
      "xlsm",
      "xls",
      "csv",
    ]
      .map(function (x) {
        return "." + x;
      })
      .join(",");
  
    return (
      <form className="form-inline">
        <div className="form-group">
          <input
            type="file"
            className="form-control"
            id="file"
            accept=".xlsx, .xls"
            onChange={handleChange}
            style={{ display: "block", margin: "10px auto" }}
          />
        </div>
      </form>
    );
  };

export default DataInput